"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.LINK_ICON_SPACING = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _interfaces = require("./interfaces");
const defaultProps = exports.defaultProps = {
  color: (0, _utils.token)('color.link.primary-default'),
  fontWeight: (0, _utils.token)('text.weight.medium'),
  textDecoration: _interfaces.LinkTextDecorationOptions.Underline,
  iconPosition: _interfaces.LinkIconPosition.Trailing,
  iconVerticalAlign: 'text-top'
};
const LINK_ICON_SPACING = exports.LINK_ICON_SPACING = (0, _utils.token)('dimensions.spacing.100');